// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Pe-z","zenCrossSiteLabel":"Qe-z","vrsnlCrossSiteLabel":"Re-z"};